import gql from "graphql-tag";

const DELETE_PROSPECT_TRAFFIC = gql`
  mutation deleteProspectTraffic($input: ProspectTrafficDeleteInput!) {
    deleteProspectTraffic(input: $input) {
      message
      code
    }
  }
`;

export default DELETE_PROSPECT_TRAFFIC;
